// extracted by mini-css-extract-plugin
export var container = "Logos-module--container--351Um";
export var container__item = "Logos-module--container__item--1sbbW";